import { render, staticRenderFns } from "./customDropDown.vue?vue&type=template&id=08a61610&scoped=true&"
import script from "./customDropDown.vue?vue&type=script&lang=js&"
export * from "./customDropDown.vue?vue&type=script&lang=js&"
import style0 from "./customDropDown.vue?vue&type=style&index=0&id=08a61610&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a61610",
  null
  
)

export default component.exports